import React from 'react';

const SectionHeading = ({ tag, title, desc }) => (
  <div className="text-center mb-16 max-w-3xl mx-auto">
    {tag && (
      <span className="inline-block px-4 py-1 rounded-full text-xs font-mono tracking-widest uppercase border border-primary/30 text-primary mb-4">
        {tag}
      </span>
    )}
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">{title}</h2>
    {desc && <p className="text-gray-400 text-lg leading-relaxed">{desc}</p>}
  </div>
);

export default SectionHeading;
